import React from 'react';
import { motion } from 'framer-motion';
import splitLine from 'ReactApp/Services/MotionHelpers/SplitLine';
import Select2Wrapper from '../Select2Wrapper/Select2Wrapper';
import { ShowableProductCard } from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { observer } from "mobx-react";

const sentence = {
    visible: {
        transition: {
            delay: 1,
            staggerChildren: 0.05,
            staggerDirection: 1,
        },
    },
}

type RealModifierSwitcherV1Props = {
    productCard: ShowableProductCard
}
type RealModifierOption = {
    id: number,
    text: string,
}

const RealModifierSwitcherV1 = observer((props: RealModifierSwitcherV1Props) => {

    function handleSelectChange(event: React.ChangeEvent<HTMLSelectElement>) {
        props.productCard.switchRealModifier(
            Number(event.currentTarget.value)
        );
    }

    if (!props.productCard.realModifiers.length) {
        return <></>;
    }

    let asOptions: RealModifierOption[] = props.productCard.realModifiers.map(
        v => {
            return {id: v.realModifierId, text: v.label, isActive: v.isActive};
        }
    );

    let commonPluginOptions = {
        "iconString": `
            <svg class="icon-v1">
                <use xlink:href="/build/sprite.svg#search-input-icon">
                </use>
            </svg>
        `
    };

    return (
        <div className="real-modifier-switcher-v1">
            <div className="form-group-select-v1">
                <div className="form-group-select-v1__select">
                    <div 
                        className="select-v2" 
                        data-common-plugin-options={JSON.stringify(commonPluginOptions)}
                        >
                        <Select2Wrapper value={props.productCard.realModifierId ?? undefined} onChange={handleSelectChange}
                            className='select-2__element'
                            data={{
                                ...commonPluginOptions,
                                placeholder: "Выберите",
                                data: asOptions
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

})

export default RealModifierSwitcherV1;